export { Models } from './Models';
export { PropsType as PropsType, TabBarPropsType } from './PropsType';
export { Tabs } from './Tabs';
export { DefaultTabBar } from './DefaultTabBar';



// WEBPACK FOOTER //
// ./components/tabs/rmc-tabs/index.tsx